function handleCmsLinks_default(el, callback = (link) => {
}) {
  if (!el.querySelectorAll) {
    return;
  }
  const links = el.querySelectorAll("a");
  for (let i = 0, j = links.length; i < j; i++) {
    links[i].addEventListener("click", (e) => {
      let target = e.target;
      while (target) {
        if (target instanceof HTMLAnchorElement) {
          const link = target.getAttribute("href");
          if (link.startsWith("/")) {
            e.preventDefault();
            callback(link);
          }
          break;
        }
        target = target.parentNode;
      }
    });
  }
}
export {
  handleCmsLinks_default as default
};
